import { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { usePlatformAccessLevel } from '../features/platformPermissions/usePlatformAccessLevel';
import { JobRolesTab } from '../features/competence/JobRolesTab';
import { CompetenceRecordsTab } from '../features/competence/CompetenceRecordsTab';
import { TrainingsTab } from '../features/competence/TrainingsTab';

export function CompetencePage() {
  const { canEdit } = usePlatformAccessLevel('competence.access');
  const [tab, setTab] = useState('puestos');

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-foreground">Competencias y capacitaciones</h1>
        <p className="text-sm text-muted-foreground mt-1">
          Perfiles de puesto, competencias por persona y plan de capacitación (ISO 7.2).
        </p>
      </div>

      <Tabs value={tab} onValueChange={setTab}>
        <TabsList>
          <TabsTrigger value="puestos">Puestos</TabsTrigger>
          <TabsTrigger value="personas">Personas / Competencias</TabsTrigger>
          <TabsTrigger value="capacitaciones">Capacitaciones</TabsTrigger>
        </TabsList>
        <TabsContent value="puestos">
          <JobRolesTab canEdit={canEdit} />
        </TabsContent>
        <TabsContent value="personas">
          <CompetenceRecordsTab canEdit={canEdit} />
        </TabsContent>
        <TabsContent value="capacitaciones">
          <TrainingsTab canEdit={canEdit} />
        </TabsContent>
      </Tabs>
    </div>
  );
}

export default CompetencePage;
